<template>
  <category-numeric-input-popup title="הוספת קטגוריה למעקב" @back-clicked="back" @save="save"
                                :cashculations="cashculations" :place-holder="placeholder">
    <template v-slot:sub-title>
      <div class="title">כמה כסף צפוי לצאת על
        <span class="bold">הוצאות {{ selectedTrackingCategory.label }}</span>
        בחודש {{ currentMonthName }}{{ timeFrame }}?
      </div>
    </template>
    <template v-if="selectedTrackingCategory.historyAverage" v-slot:comment>
      <div class="comment">ממוצע שלושת החודשים הקודמים</div>
    </template>
  </category-numeric-input-popup>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CategoryNumericInputPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/CategoryNumericInputPopup';
import cashflowViewConsts from '@/constants/cashflow-view';
import Segment from '@/Segment';
import dateUtils from '@/utils/dates';

export default {
  name: 'CreateTrackingCategoryAmountPopup',
  components: {
    CategoryNumericInputPopup,
  },
  computed: {
    ...mapState('createTrackingCategory', ['selectedTrackingCategory', 'amount']),
    ...mapState('cashflowView', ['cashflowUITree', 'cashflowStartDay', 'presentedBudgetDate']),
    ...mapGetters('createTrackingCategory', ['transactionsToTrackAmount']),
    currentMonthName() {
      return dateUtils.getHebrewMonth(this.presentedBudgetDate);
    },
    variableExpenses() {
      return this.cashflowUITree[cashflowViewConsts.cashflowTypes.variableExpense];
    },
    upToNowAmount() {
      return this.variableExpenses.upToNowAmount - this.transactionsToTrackAmount;
    },
    recommendedAmount() {
      return this.variableExpenses.recommendedOrExpectedAmount - (this.amount || 0);
    },
    cashculations() {
      return {
        untilNowAmount: this.upToNowAmount,
        recommendedAmount: this.recommendedAmount,
      };
    },
    placeholder() {
      return this.selectedTrackingCategory.historyAverage ? Math.round(this.selectedTrackingCategory.historyAverage) : 0;
    },
    timeFrame() {
      if (this.cashflowStartDay === 1) {
        return '';
      }
      const startDate = dateUtils.startOfMonthText(this.presentedBudgetDate, this.cashflowStartDay);
      const endDate = dateUtils.endOfMonthText(this.presentedBudgetDate, this.cashflowStartDay);
      return ` (מ־${startDate} עד ${endDate})`;
    },
  },
  created() {
    Segment.trackUserInteraction('CreateTrackingCategoryAmount_Entered', {
      selectedTrackingCategory: this.selectedTrackingCategory,
    });
  },
  methods: {
    back() {
      Segment.trackUserInteraction('CreateTrackingCategoryAmount_BackClicked', {
        selectedTrackingCategory: this.selectedTrackingCategory,
      });
      this.$emit('back-clicked');
    },
    async save() {
      Segment.trackUserInteraction('CreateTrackingCategoryAmount_SaveClicked', {
        selectedTrackingCategory: this.selectedTrackingCategory,
        amount: this.amount,
      });
      this.$emit('done-clicked');
    },
  },
};
</script>
